import { render, staticRenderFns } from "./StretchSmall.vue?vue&type=template&id=47a19e72&scoped=true"
import script from "./StretchSmall.vue?vue&type=script&lang=js"
export * from "./StretchSmall.vue?vue&type=script&lang=js"
import style0 from "./StretchSmall.vue?vue&type=style&index=0&id=47a19e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a19e72",
  null
  
)

export default component.exports